import { jsx as _jsx } from "react/jsx-runtime";
import Paragraph from '../Typography/Paragraph/Paragraph';
import styles from './TextError.module.scss';
import cn from 'classnames';
const TextError = ({ text, className }) => {
    return _jsx(Paragraph, { size: 1, className: cn(styles.element, className), title: text });
};
export default TextError;
